import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import { Link, useNavigate } from "react-router-dom";
import Cookies from 'js-cookie';

const api = "https://apideneme.com.tr/api";

const ShowItem = () => {
    const [items, setItems] = useState([]);
    const [filteredItems, setFilteredItems] = useState([]);
    const [searchTerm, setSearchTerm] = useState("");
    const [isAdmin, setIsAdmin] = useState(false);
    const [showLinks, setShowLinks] = useState(false);
    const [message, setMessage] = useState("");
    const navigate = useNavigate();
    const menuRef = useRef(null);

    useEffect(() => {
        const userId = Cookies.get('user_id');
        if (userId !== "1") {
            setMessage("Admin değilsiniz. Yönlendiriliyorsunuz...");
            Cookies.remove('user_token');
            Cookies.remove('user_id');
            localStorage.removeItem('user_id');
            setTimeout(() => navigate('/'), 2000);
        } else {
            setIsAdmin(true);
            getAllItems();
        }
    }, [navigate]);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (menuRef.current && !menuRef.current.contains(event.target)) {
                setShowLinks(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    const getAllItems = async () => {
        const userId = localStorage.getItem('user_id');
        try {
            const response = await axios.get(`${api}/items`, { params: { user_id: userId } });
            const sortedItems = response.data.sort((a, b) => {
                if (a.user_id === b.user_id) {
                    return a.id - b.id;
                }
                return a.user_id - b.user_id;
            });
            setItems(sortedItems);
            setFilteredItems(sortedItems);
        } catch (error) {
            console.error("Verileri alırken hata oluştu:", error);
        }
    };

    const deleteItem = async (id) => {
        const userId = localStorage.getItem('user_id');
        try {
            await axios.delete(`${api}/item/${id}`, { params: { user_id: userId } });
            getAllItems();
        } catch (error) {
            console.error("Silme işlemi sırasında hata oluştu:", error);
            alert("Silme işlemi başarısız oldu. Lütfen tekrar deneyin.");
        }
    };

    const handleSearch = (e) => {
        setSearchTerm(e.target.value);
        if (e.target.value === "") {
            setFilteredItems(items);
        } else {
            const filtered = items.filter((item) =>
                item.user_id.toString().includes(e.target.value)
            );
            setFilteredItems(filtered);
        }
    };

    const handleLogout = () => {
        Cookies.remove('user_token');
        Cookies.remove('user_id');
        localStorage.removeItem('user_id');
        navigate('/');
    };

    const handleAdminClick = () => {
        setShowLinks(!showLinks);
    };

    return (
        <div>
            {message && <div style={{ color: "red", fontWeight: "bold" }}>{message}</div>}

            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", position: "relative" }}>
                <div style={{ boxShadow: "0 0 5px rgba(0, 123, 255, 0.5)", flexShrink: 0, marginLeft: "4px" }}>
                    <input
                        type="text"
                        className="form-control"
                        placeholder="Search by User ID"
                        value={searchTerm}
                        onChange={handleSearch}
                        style={{ width: "200px", display: "inline-block" }}
                    />
                </div>

                <div style={{ flexGrow: 1, textAlign: "center"}}>
                    <Link to="/create" className="btn btn-success text-white mb-2 mt-2">Create</Link>
                </div>

                <div style={{ position: "relative" }}>
                    <button onClick={handleAdminClick} className="btn text-white mb-2 mt-2" style={{ backgroundColor: "#2af5aa", marginRight: "5px" }}>ADMİN</button>
                    <button onClick={handleLogout} className="btn btn-danger" style={{ marginRight: "5px" }}>EXIT</button>
                    
                    {showLinks && (
                        <div ref={menuRef} style={{
                        position: "absolute",
                        top: "100%",
                        right: "0",
                        backgroundColor: "#2af5aa",
                        boxShadow: "0px 4px 8px rgba(0,0,0,0.2)",
                        padding: "10px",
                        borderRadius: "5px",
                        zIndex: 1000,
                        whiteSpace: "nowrap",
                    }}>

                        {/* Admin Page 1 Link */}
                        <Link
                            to="/showusers"
                            style={{
                                color: "white",
                                backgroundColor: "#2af5aa",
                                border: "none",
                                padding: "5px 14px",
                                marginBottom: "5px",
                                cursor: "pointer",
                                borderRadius: "3px",
                                display: "block",
                                width: "100%",
                                textAlign: "left",
                                borderBottom: "2px solid white",
                                textDecoration: "none"
                            }}
                        >
                            User Informations
                        </Link>
                    
                        {/* Admin Page 1 Link */}
                        <Link
                            to="/showusers"
                            style={{
                                color: "white",
                                backgroundColor: "#2af5aa",
                                border: "none",
                                padding: "5px 14px",
                                cursor: "pointer",
                                borderRadius: "3px",
                                display: "block",
                                width: "100%",
                                textAlign: "left",
                                textDecoration: "none"
                            }}
                        >
                            Admin Page 2
                        </Link>

                    </div>
                    )}
                </div>
            </div>

            <table className="table table-striped">
                <thead className="bg-success text-white">
                    {isAdmin && <th>User ID</th>}
                    <th>Id</th>
                    <th>Name</th>
                    <th>Description</th>
                    <th>Price</th>
                    <th>Image_link</th>
                    <th>Action</th>
                </thead>
                <tbody>
                    {filteredItems.map((item) => (
                        <tr key={item.id}>
                            {isAdmin && (
                                <td>{item.user_id || <span style={{ color: "red", fontWeight: "bold" }}>Veri Yok</span>}</td>
                            )}
                            <td>{item.id}</td>
                            <td>{item.name || <span style={{ color: "red", fontWeight: "bold" }}>Veri Yok</span>}</td>
                            <td>{item.description || <span style={{ color: "red", fontWeight: "bold" }}>Veri Yok</span>}</td>
                            <td>{item.price || <span style={{ color: "red", fontWeight: "bold" }}>Veri Yok</span>}</td>
                            <td>{item.image || <span style={{ color: "red", fontWeight: "bold" }}>Veri Yok</span>}</td>
                            <td>
                                <Link to={`/edit/${item.id}`} className="btn btn-warning" style={{ marginRight: "1px" }}>Edit</Link>
                                <button onClick={() => deleteItem(item.id)} className="btn btn-danger">Delete</button>
                                <button
                                    onClick={() => {
                                        if (item.image) { window.open(`http://127.0.0.1:8000/storage/${item.image}`, "_blank"); }
                                    }}
                                    className="btn text-white" style={{ backgroundColor: "turquoise", marginLeft: "1px" }} disabled={!item.image}
                                > Open Image </button>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
};

export default ShowItem;
